const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Border_box",
    "data-name": "Border box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.14,23.13H2.84c-1.1,0-2-.9-2-2V2.83C.84,1.73,1.74.83,2.84.83h18.3c1.1,0,2,.9,2,2v18.3c0,1.1-.9,2-2,2ZM5.22,10l.32,1.69h1.4l-1.44-7.42h-1.73l-1.61,7.42h1.4l.33-1.69h1.33ZM4.04,8.88l.27-1.54c.08-.43.19-1.2.26-1.69h.03c.07.5.17,1.23.24,1.68l.24,1.55h-1.06ZM7.53,4.28v4.58c0,1.86.6,2.93,2.16,2.93,1.43,0,2.15-1.03,2.15-2.94v-4.57h-1.44v4.82c0,1.12-.3,1.42-.72,1.42-.37,0-.7-.33-.7-1.42v-4.82h-1.44ZM13.88,11.69h1.44v-6.08h1.32v-1.33h-4.07v1.33h1.31v6.08ZM19.34,4.19c-1.64,0-2.44,1.75-2.44,3.77s.66,3.82,2.34,3.82c1.41,0,2.4-1.13,2.4-3.93,0-1.69-.51-3.66-2.3-3.66ZM19.28,5.44c.65,0,.85,1.18.85,2.48,0,1.51-.23,2.61-.84,2.61s-.9-.86-.9-2.54c0-1.6.32-2.54.89-2.54ZM3.4,19.69h1.44v-2.76h.29c.59,0,1.34-.22,1.8-.7.39-.42.63-.98.63-1.78,0-.63-.2-1.24-.64-1.63-.48-.45-1.16-.57-2.01-.57-.55,0-1.1.05-1.51.14v7.31ZM4.84,13.47c.09-.03.22-.06.35-.06.67,0,.94.51.94,1.16,0,.69-.33,1.21-1.06,1.21-.09,0-.17,0-.23-.02v-2.29ZM8.43,19.69h3.34v-1.22h-1.9v-6.19h-1.44v7.42ZM15.21,18l.32,1.69h1.4l-1.44-7.42h-1.73l-1.61,7.42h1.4l.33-1.69h1.33ZM14.02,16.88l.28-1.54c.08-.43.19-1.2.26-1.69h.03c.07.5.17,1.23.24,1.68l.24,1.55h-1.06ZM19.71,19.69v-2.89l1.66-4.52h-1.5l-.44,1.74c-.13.53-.25,1.07-.34,1.61h-.02c-.11-.55-.25-1.1-.39-1.57l-.51-1.77h-1.54l1.63,4.58v2.84h1.44Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoplay);
export default __webpack_public_path__ + "static/media/autoplay.6d0bfaac647593323b2c2b1882095734.svg";
export { ForwardRef as ReactComponent };